import Resource from '@/docs-partials/resources';
import * as React from 'react';
export default {
  Resource,
  React
};